import { render, staticRenderFns } from "./ShowTeacher.vue?vue&type=template&id=0aa5288d&scoped=true&"
import script from "./ShowTeacher.vue?vue&type=script&lang=js&"
export * from "./ShowTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ShowTeacher.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ShowTeacher.vue?vue&type=style&index=1&id=0aa5288d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5288d",
  null
  
)

export default component.exports